var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6624_50102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.37916 6.47315L8.23766 10.3306C8.31133 10.4043 8.34766 10.493 8.34666 10.5966C8.34566 10.7 8.30833 10.7886 8.23466 10.8626C8.16066 10.9363 8.07183 10.9731 7.96816 10.9731C7.86483 10.9731 7.77616 10.9363 7.70216 10.8626L3.88416 7.04114C3.80349 6.96048 3.74449 6.87048 3.70716 6.77114C3.66983 6.67181 3.65133 6.57248 3.65166 6.47315C3.65199 6.37381 3.67049 6.27448 3.70716 6.17515C3.74383 6.07581 3.80283 5.98581 3.88416 5.90515L7.70516 2.08315C7.77916 2.00948 7.86749 1.97315 7.97016 1.97415C8.07249 1.97515 8.16049 2.01248 8.23416 2.08615C8.30783 2.15981 8.34466 2.24848 8.34466 2.35215C8.34466 2.45581 8.30783 2.54431 8.23416 2.61765L4.37916 6.47315Z",
    fill: "#555B6A",
    stroke: "#555B6A",
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6624_50102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.fbb04844b523017da52d1296d96b88c3.svg";
export { ForwardRef as ReactComponent };